export default "__VITE_PUBLIC_ASSET__69e1ed94__"